import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Trash2 } from 'lucide-react';

import { productsApi } from '../../../api/products.js';
import { Input } from '../../../components/ui/Input.jsx';
import { Switch } from '../../../components/ui/Switch.jsx';

/**
 * Associate products to a consultation and flag whether each was purchased.
 * `value` is an array of { productId, name, sku, purchased }.
 */
export function ConsultationProductPicker({ value, onChange }) {
  const [q, setQ] = useState('');
  const [sku, setSku] = useState('');
  const active = q.trim().length >= 2 || sku.trim().length >= 1;
  const searchQuery = useQuery({
    queryKey: ['products', 'consult-pick', q, sku],
    enabled: active,
    queryFn: () => productsApi.list({ q: q.trim() || undefined, sku: sku.trim() || undefined, limit: 8 })
  });
  const results = (searchQuery.data && searchQuery.data.items) || [];

  const add = (p) => {
    if (value.some((i) => i.productId === p._id)) return;
    onChange([...value, { productId: p._id, name: p.name, sku: p.sku, purchased: false }]);
    setQ(''); setSku('');
  };
  const toggle = (productId) => onChange(value.map((i) => (i.productId === productId ? { ...i, purchased: !i.purchased } : i)));
  const remove = (productId) => onChange(value.filter((i) => i.productId !== productId));

  return (
    <div className="flex flex-col gap-3">
      <div className="relative">
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          <Input label="Aggiungi prodotto" placeholder="Cerca per nome (min 2 caratteri)" value={q} onChange={(e) => { setQ(e.target.value); setSku(''); }} />
          <Input label="SKU" placeholder="codice SKU" value={sku} onChange={(e) => { setSku(e.target.value); setQ(''); }} />
        </div>
        {active && results.length > 0 && (
          <div className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md border border-border bg-surface-elevated shadow-elevated">
            {results.map((p) => (
              <button key={p._id} type="button" className="flex w-full items-center justify-between gap-2 px-3 py-2 text-left text-sm hover:bg-surface-subtle" onClick={() => add(p)}>
                <span className="truncate text-ink">{p.name}</span>
                <span className="shrink-0 text-xs text-ink-faint">{p.sku}</span>
              </button>
            ))}
          </div>
        )}
      </div>

      {value.length > 0 && (
        <div className="flex flex-col gap-1.5">
          {value.map((i) => (
            <div key={i.productId} className="flex items-center justify-between gap-3 rounded-lg border border-border bg-surface px-3 py-2">
              <span className="min-w-0">
                <span className="block truncate text-sm text-ink">{i.name}</span>
                <span className="block text-xs text-ink-faint">{i.sku}</span>
              </span>
              <div className="flex shrink-0 items-center gap-3">
                <label className="flex items-center gap-1.5 text-xs text-ink-muted">
                  Acquistato
                  <Switch checked={i.purchased} onChange={() => toggle(i.productId)} />
                </label>
                <button type="button" className="text-ink-muted hover:text-danger" onClick={() => remove(i.productId)}><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
